/* eslint-disable @typescript-eslint/camelcase */

import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Status } from 'hooks/requests/fetchUtils';
import useFetchApi from 'hooks/useFetchApi';
import useQueryParameters from 'hooks/useQueryParameters';

import { incrementAttempts } from 'state/otpCode';
import { lockFields } from 'state/creditApplication';

const PATH = '/api/otp_verify';

type OTPVerificationHook = () => [
  ({ otpCode }: { otpCode: string }) => Promise<void>,
  Status,
];

export class OTPVerificationError extends Error {}

export const useOTPVerification: OTPVerificationHook = () => {
  const [status, fetch] = useFetchApi();
  const { mockVOTP } = useQueryParameters();
  const dispatch = useDispatch();
  const verifyOTPCode = useCallback(
    async ({ otpCode }: { otpCode: string }): Promise<void> => {
      const response = await fetch(PATH, {
        method: 'POST',
        body: {
          otpCode,
          mockOtpResponse: mockVOTP,
        },
      });

      // TODO: Service is not finished. 400 from service currently does not
      // return any body. Expect it to have message in the future.
      if (!response.ok) {
        dispatch(incrementAttempts());
        // const body = await response.json();
        // const error = body.message;
        return Promise.reject(new OTPVerificationError(/*error*/));
      }

      dispatch(lockFields({ mobilePhone: true }));
    },
    [fetch, mockVOTP, dispatch],
  );

  return [verifyOTPCode, status];
};

export default useOTPVerification;
